require("source-map-support").install(), function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("Popover", [], t) : "object" == typeof exports ? exports.Popover = t() : e.Popover = t();
}(this, function () {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "/", r(r.s = 398);
  }({
    0: function _(e, t) {
      e.exports = require("react");
    },
    197: function _(e, t, r) {
      "use strict";

      r.r(t);
      var n = r(34);
      t.default = n.a;
    },
    2: function _(e, t) {
      e.exports = require("styled-components");
    },
    3: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/taggedTemplateLiteral");
    },
    34: function _(e, t, r) {
      "use strict";

      var n = r(6),
          o = r.n(n),
          i = r(3),
          u = r.n(i),
          c = r(0),
          p = r.n(c),
          f = r(48),
          a = r.n(f),
          s = (r(71), r(72), r(2));

      function l(e, t) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function d() {
        var e = u()(["\n  border-radius: 5px;\n  font-size: unset;\n  padding: 0px;\n  line-height: unset;\n  text-align: unset;\n"]);
        return d = function d() {
          return e;
        }, e;
      }

      var b = r.n(s)()(a.a)(d()),
          y = function y(e) {
        return p.a.createElement(b, function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? l(Object(r), !0).forEach(function (t) {
              o()(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l(Object(r)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
          }

          return e;
        }({}, e));
      };

      y.defaultProps = {
        animation: "fade",
        interactive: !0,
        interactiveBorder: 10,
        theme: "rr",
        trigger: "click"
      }, t.a = y;
    },
    398: function _(e, t, r) {
      e.exports = r(197);
    },
    48: function _(e, t) {
      e.exports = require("@tippy.js/react");
    },
    6: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/defineProperty");
    },
    71: function _(e, t) {
      e.exports = require("tippy.js/dist/tippy.css");
    },
    72: function _(e, t, r) {}
  });
});